// extracted by mini-css-extract-plugin
module.exports = {"rating":"Uh","numberOfStars":"Vh","count":"Wh"};